import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { sendMetricsData } from 'src/app/core/core.actions';
import { WINDOW } from 'src/app/core/core.module';
import { TicketCandidate } from 'src/app/travelx/models/ticket-candidate.model';
import { CreateNewTicketComponent } from 'src/app/travelx/tickets/create-new-ticket/create-new-ticket.component';

@Component({
    selector: 'nova-create-ticket-menu',
    styleUrls: [],
    templateUrl: './create-ticket-menu.component.html',
    standalone: true,
    imports: [MatLegacyMenuModule, MatLegacyButtonModule]
})
export class CreateTicketMenuComponent {
    @Input() candidateId: number;
    @Input() candidateName: string;
    @Input() showNewSubmittal = false;
    @Output() onNewSubmittalClick = new EventEmitter();

    constructor(
        private readonly _router: Router,
        private readonly _matDialog: MatDialog,
        private readonly _store: Store<unknown>,
        @Inject(WINDOW) private readonly _window: Window
    ) {}

    onNewSubmittal(): void {
        this.onNewSubmittalClick.emit();
    }

    onTicket(): void {
        this._matDialog.open(CreateNewTicketComponent, {
            panelClass: ['nova__dialog'],
            disableClose: true,
            data: {
                candidate: {
                    id: this.candidateId,
                    name: this.candidateName
                } as TicketCandidate
            }
        });
    }

    createApplication(): void {
        const metricsData = { message: 'create application button was clicked' };
        this._store.dispatch(
            sendMetricsData({
                eventName: 'create-application-button-clicked',
                data: JSON.parse(JSON.stringify(metricsData))
            })
        );
        const url = `travelxnew/candidates/${this.candidateId || ':id'}/create-application`;
        this._router.navigateByUrl(url);
    }
}
